import { getAllRows } from 'pages/qa-spec/utils';

export const coverIngredientStatementsData = ({
  data,
  currentIngredient,
  ingredientStatementValue,
}) => {
  let ingredientStatements = [];
  if (currentIngredient?.index !== null) {
    ingredientStatements = data?.ingredientStatements?.map((item) => {
      if (currentIngredient?.index === item?.index)
        return {
          ...currentIngredient,
          ingredients: ingredientStatementValue,
        };
      return item;
    });
  } else {
    const defaultIngredientStatements = data?.ingredientStatements ?? [];

    ingredientStatements = [
      ...defaultIngredientStatements,
      {
        ...currentIngredient,
        ingredients: ingredientStatementValue,
      },
    ];
  }
  return ingredientStatements;
};

export const createIngredientParams = ({ formInst, gridInst }) => {
  const { ingredientClaims } = formInst.getFieldsValue();

  const ingredientListForm = getAllRows(gridInst).map((ingredientItem) => {
    // ingredientsPartOf != null
    if (ingredientItem?.isChild) {
      const spittedIngredientsPartOf =
        ingredientItem?.ingredientsPartOf?.split('.');

      const parentId =
        spittedIngredientsPartOf[spittedIngredientsPartOf?.length - 1]; // the last value = parentId

      const value = spittedIngredientsPartOf.slice(0, -1).join('.'); // the rest is ingredientsPartOf

      return {
        ...ingredientItem,
        ingredientsPartOf: value,
        ingredientsPartOfId: parentId,
        digitalAssetId: ingredientItem?.documents?.digitalAssetId,
      };
    }
    return {
      ...ingredientItem,
      ingredientsPartOfId: null,
      digitalAssetId: ingredientItem?.documents?.digitalAssetId,
    };
  });

  const convertToLevelIdx = (rows) => {
    // 1. Map: compositeKey → node
    const nodeMap = new Map();

    rows.forEach((row) => {
      const key = `${row.nameOfIngredients}.${row.id}`;
      nodeMap.set(key, row);
    });

    // 2. Build children map
    const childrenMap = new Map();

    rows.forEach((row) => {
      if (!row.ingredientsPartOf) return;

      const parentKey = `${row.ingredientsPartOf}.${row.ingredientsPartOfId}`;

      if (!childrenMap.has(parentKey)) {
        childrenMap.set(parentKey, []);
      }

      childrenMap.get(parentKey).push(row);
    });

    const result = [];

    // 3. DFS
    const dfs = (node, levelIdx, parentLevelIdx = null) => {
      const currentKey = `${node.nameOfIngredients}.${node.id}`;

      // resolve parent
      const parentKey = node.ingredientsPartOf
        ? `${node.ingredientsPartOf}.${node.ingredientsPartOfId}`
        : null;

      const parentNode = parentKey ? nodeMap.get(parentKey) : null;

      const newNode = {
        ...node,
        id: levelIdx,
        levelIdx,
        rawId: node.id,

        ingredientsPartOfId: parentLevelIdx,
        ingredientsPartOf: parentNode ? parentNode.nameOfIngredients : null,
      };

      result.push(newNode);

      const children = childrenMap.get(currentKey) || [];

      children.forEach((child, index) => {
        dfs(child, `${levelIdx}.${index + 1}`, levelIdx);
      });
    };

    // 4. roots
    const roots = rows.filter((r) => !r.ingredientsPartOf);

    roots.forEach((root, index) => {
      dfs(root, `${index + 1}`);
    });

    return result;
  };
  var newData = convertToLevelIdx(ingredientListForm);
  const submitValue = {
    ingredientClaims,
    ingredients: newData,
  };
  return submitValue;
};
